import axiosInstance from "../../api/axios";

// Category List
export const getCategory = async () => {
  try {
    const response = await axiosInstance.get(`/category/list/`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Category Create
export const createCategory = async (categoryData: { name: string }) => {
  try {
    const response = await axiosInstance.post(`/category/`, categoryData);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Category Update
export const updateCategory = async (id: number, categoryData: { name: string }) => {
  try {
    const response = await axiosInstance.put(`/category/${id}`, categoryData);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Category By ID
export const getCategoryById = async (id: number) => {
  try {
    const response = await axiosInstance.get(`/category/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Category Delete
export const deleteCategory = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/category/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};